import * as Oazapfts from "oazapfts/lib/runtime";
import * as QS from "oazapfts/lib/runtime/query";
import {UserListRequest , OrganizationStatsRequest} from "@/generated/adminapi";
import {
    DatabaseTableListResponse,
    DatabaseTableSchemaResponse,
    DatabaseQueryRequest,
    DatabaseQueryResponse
} from "@/types/dataManagement";


type GenericResponse = {
    code: number;
    message: string | object;
};
export const defaults: Oazapfts.RequestOpts = {
    baseUrl: "http://localhost:8081/api",
};
const oazapfts = Oazapfts.runtime(defaults);


/**
 * 어린이 리스트 엑셀 다운로드
 */
export function v2AdminListKidExcelDownload(userListRequest: UserListRequest, { details, sorting, pagination }: {
    details?: boolean | null;
    sorting?: any;
    pagination?: any;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/kids/excel.do${QS.query(QS.form({
        details,
        sorting,
        pagination
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: userListRequest
    }));
}
/**
 * 약속 진행 엑셀 다운로드
 */
export function v2AdminListHistoryExcelDownload({ devops, filter, sorting, pagination }: {
    devops?: boolean | null;
    filter?: any;
    sorting?: any;
    pagination?: any;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/histories/excel.do${QS.query(QS.form({
        devops,
        filter,
        sorting,
        pagination
    }))}`, {
        ...opts
    });
}
/**
 * 기관별 약속 진행 엑셀 다운로드
 */
export function v2AdminListHistoryOrganizationExcelDownload({ filter, sorting, pagination }: {
    filter?: any;
    sorting?: any;
    pagination?: any;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/histories/organization/excel.do${QS.query(QS.form({
        filter,
        sorting,
        pagination
    }))}`, {
        ...opts
    });
}
/**
 * 선택 약속 엑셀 다운로드
 */
export function v2AdminScheduleTimeTableExcelDownload({ filter, sorting, pagination }: {
    filter?: any;
    sorting?: any;
    pagination?: any;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/schedule/timetable/excel.do${QS.query(QS.form({
        filter,
        sorting,
        pagination
    }))}`, {
        ...opts
    });
}
/**
 * 하루 일기 엑셀 다운로드
 */
export function v2AdminMessageExcelDownload({ filter, sorting, pagination }: {
    filter?: any;
    sorting?: any;
    pagination?: any;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/message/excel.do${QS.query(QS.form({
        filter,
        sorting,
        pagination
    }))}`, {
        ...opts
    });
}
/**
 * 행동 평가 및 학교 준비도 평가 엑셀 다운로드
 */
export function v2AdminSurveyExcelDownload({ schoolFlag, filter, sorting, pagination }: {
    schoolFlag?: boolean | null;
    filter?: any;
    sorting?: any;
    pagination?: any;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/survey/excel.do${QS.query(QS.form({
        schoolFlag,
        filter,
        sorting,
        pagination
    }))}`, {
        ...opts
    });
}
/**
 * 자기 효능감 평가 엑셀 다운로드
 */
export function v2AdminAssessmentExcelDownload({ filter, sorting, pagination }: {
    filter?: any;
    sorting?: any;
    pagination?: any;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/assessment/excel.do${QS.query(QS.form({
        filter,
        sorting,
        pagination
    }))}`, {
        ...opts
    });
}
/**
 * 기관 정보 엑셀 다운로드
 */
export function v2AdminOrganizationStatsExcelDownload(organizationStatsRequest: OrganizationStatsRequest, { sorting, pagination }: {
    sorting?: any;
    pagination?: any;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/organization/detail/excel.do${QS.query(QS.form({
        sorting,
        pagination
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: organizationStatsRequest
    }));
}
/**
 * 기관 세부 정보 엑셀 다운로드
 */
export function v2AdminOrganizationDetailStatsExcelDownload({ filter, sorting, pagination }: {
    filter?: any;
    sorting?: any;
    pagination?: any;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/organization/detail/excel.do${QS.query(QS.form({
        filter,
        sorting,
        pagination
    }))}`, {
        ...opts
    });
}
/**
 * 어린이 별 CNT 정보 엑셀 다운로드
 */
export function v2AdminRetrieveCntExcelDownload(userId: string, { sorting, pagination }: {
    sorting?: any;
    pagination?: any;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/cnt/${userId}/excel.do${QS.query(QS.form({
        sorting,
        pagination
    }))}`, {
        ...opts
    });
}
/**
 * 기관별 CNT 게임 결과 엑셀 다운로드
 */
export function v2AdminListCntOrganizationExcelDownload({ filter, sorting, pagination }: {
    filter?: any;
    sorting?: any;
    pagination?: any;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/cnt/organization/excel.do${QS.query(QS.form({
        filter,
        sorting,
        pagination
    }))}`, {
        ...opts
    });
}

/**
 * 데이터베이스 테이블 목록 조회
 */
export function v2AdminListDatabaseTables(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: DatabaseTableListResponse;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/database/tables`, {
        ...opts
    });
}

/**
 * 데이터베이스 테이블 스키마 조회
 */
export function v2AdminRetrieveDatabaseTableSchema(tableName: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: DatabaseTableSchemaResponse;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/database/tables/${encodeURIComponent(tableName)}/schema`, {
        ...opts
    });
}

/**
 * 데이터베이스 쿼리 실행
 */
export function v2AdminQueryDatabaseTable(databaseQueryRequest: DatabaseQueryRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: DatabaseQueryResponse;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/database/query`, oazapfts.json({
        ...opts,
        method: "POST",
        body: databaseQueryRequest
    }));
}

/**
 * 데이터베이스 쿼리 결과 CSV 다운로드
 */
export function v2AdminExportDatabaseCsv(databaseQueryRequest: DatabaseQueryRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchBlob<{
        status: 200;
        data: Blob;
    } | {
        status: 418;
        data: GenericResponse;
    }>(`/v2/admin/database/export/csv.do`, oazapfts.json({
        ...opts,
        method: "POST",
        body: databaseQueryRequest
    }));
}
